import React from 'react'

import { Box } from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import { FormContext, useForm } from 'react-hook-form'
import { isEmpty } from 'lodash'

import { LoadingFeedback } from 'components'
import { Evidences, FormActions, Question } from './components'

import helpers from 'helpers'
import schema from './schema'

const QuizQuestionTemplateForm = ({
  quizQuestionTemplate,
  onSubmit,
  onNavigate,
  redirectToHome,
  answer = {},
  evidences = [],
  previousQuestion = null,
  nextQuestion = null,
  isSubmitting = false,
}) => {
  const formMethods = useForm({
    validationSchema: schema,
    defaultValues: {
      questionAlternativeId: answer?.questionAlternativeId
        ? String(answer.questionAlternativeId)
        : '',
      hasJustification: !!answer?.justification || false,
      justification: answer?.justification || '',
      evidences: evidences || [],
    },
  })

  const { handleSubmit, watch } = formMethods
  const handleNext = handleSubmit((data) => onSubmit(data, nextQuestion))

  const questionAlternativeId = watch('questionAlternativeId')

  const evidencesRequired =
    quizQuestionTemplate?.questionAlternatives?.find(
      (alternative) => String(alternative.id) === String(questionAlternativeId),
    )?.evidencesRequired ?? false

  const evidencesList = helpers.questionnaires.resolveEvidences(
    answer,
    quizQuestionTemplate,
  )

  return (
    <FormContext {...formMethods}>
      <LoadingFeedback open={isSubmitting} />
      <form onSubmit={handleNext}>
        <Box display="flex" flexDirection="column" gridGap={8}>
          <Question quizQuestionTemplate={quizQuestionTemplate} />
          {evidencesRequired && (
            <Alert severity="info">
              A anexação de evidência é obrigatória nesta alternativa. É
              possível prosseguir, mas a questão ficará "Em Progresso" até que a
              evidência seja anexada.
            </Alert>
          )}
          {!isEmpty(evidencesList) && <Evidences evidences={evidencesList} />}
          <FormActions
            onSubmit={onSubmit}
            onNavigate={onNavigate}
            redirectToHome={redirectToHome}
            previousQuestion={previousQuestion}
            nextQuestion={nextQuestion}
            isSubmitting={isSubmitting}
          />
        </Box>
      </form>
    </FormContext>
  )
}

export default QuizQuestionTemplateForm
